module.exports = __webpack_public_path__ + "img/岗梅根.2553f6b6.jpg";